module.exports = __webpack_public_path__ + "img/wes-hicks-4-EeTnaC1S4-unsplash.97b10b0d.png";